import Styles from "./NSButton.module.css";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { IImageProps } from "../props/IImageProps";
import React from "react";
import { NSLoading, NSLoadingProps } from "./NSLoading";

export interface NSButtonOnClickProps 
{
    action: (onFinshied: () => void) => void;
    showLoading?: boolean;
}

export interface NSButtonProps extends IBaseComponentProps
{
    title?: string;
    icon?: IImageProps;
    onClick: NSButtonOnClickProps;
    disabled?: boolean;
    loading?: NSLoadingProps
}

export interface NSButtonState 
{
    clicked: boolean;
}

export class NSButton extends React.Component<NSButtonProps, NSButtonState>
{
    constructor(props: NSButtonProps)
    {
        super(props);
        this.state = { clicked: false };
        this.performClick = this.performClick.bind(this);
    }
    performClick()
    {
        if (this.props.onClick.showLoading !== false)
            this.setState({ clicked: true });
        try
        {
            this.props.onClick.action(() =>
            {
                this.setState({ clicked: false });
            });
        } catch (error: any)
        {
            this.setState({ clicked: false });
            alert(error?.message ?? error);
        }
    }
    override render(): React.ReactNode
    {
        if (this.state.clicked)
            return <NSLoading
                small
                hideTitle
                hideDesciption
                {...this.props.loading}
            ></NSLoading>

        return (
            <button id={this.props.id}
                className={`${this.props.disabled ? Styles.ns_button_disabled : Styles.ns_button} ${this.props.classList?.join(" ") ?? ""}`}
                style={this.props.style}
                onClick={() =>
                {
                    this.performClick();
                }}
                disabled={this.props.disabled}
            >
                {this.props.icon && <img {...this.props.icon} alt="Icon" width={24} height={24} />}
                {this.props.title}
            </button >
        );
    }
};